import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "questions-tab";

const keys = addTranslations(RESOURCE_NAME, {
    //Questions
    owner_assign_no_owner: {
        en: "Unassigned",
        fr: "Non assigné",
    },

    empty_questions_section_title: {
        en: "No questions found",
        fr: "Aucune question trouvée",
    },
    empty_questions_section_subtitle: {
        en: "Check that your filters are correctly defined",
        fr: "Vérifiez que vos filtres sont correctement définis",
    },

    //Answer AI suggestion
    ai_suggestion_button: { en: "Suggest", fr: "Suggestion" },
    ai_suggestion_open: { en: "Show", fr: "Afficher" },
    ai_suggestion_close: { en: "Hide", fr: "Masquer" },
    ai_suggestion_title: { en: "AI suggestion", fr: "Suggestion AI" },
    ai_suggestion_motivation: {
        en: "AI Explanation",
        fr: "Explication de l'IA",
    },
    ai_suggestion_comment: { en: "Note", fr: "Note" },
    ai_suggestion_answer: {
        en: "AI Suggested Answer",
        fr: "Réponse suggérée par l'IA",
    },
    ai_suggestion_reporting: { en: "Reporting", fr: "Reporting" },
    ai_suggestion_document_references: {
        en: "AI Suggested documents",
        fr: "Documents suggérés par l'IA",
    },
    ai_suggestion_re_generate: { en: "Re-generate", fr: "Régénérer" },
    ai_suggestion_ignore_all: { en: "Ignore all", fr: "Ignorer tout" },
    ai_suggestion_ignore: { en: "Ignore", fr: "Ignorer" },
    ai_suggestion_confirm_all: { en: "Accept all", fr: "Accepter tout" },
    ai_suggestion_confirm: { en: "Accept", fr: "Accepter" },
    ai_suggestion_unsuccessful: {
        en: "AI couldn't generate a suggestion for this question",
        fr: "AI n'a pas pu générer une suggestion pour cette question",
    },
    ai_suggestion_error: {
        en: "AI unable to generate suggestion",
        fr: "L'IA n'a pas pu générer une suggestion",
    },

    //Document citation tooltip
    insert_tooltip: { en: "Insert", fr: "Insérer" },
    document_citation_tooltip_document_name: { en: "Document", fr: "Document" },
    document_citation_tooltip_content: { en: "Content", fr: "Contenu" },
    document_citation_tooltip_edited: { en: "Edited", fr: "Modifié" },
    last_edited_by: {
        en: "On {{date}} by {{firstName}} {{lastName}}",
        fr: "Le {{date}} par {{firstName}} {{lastName}}",
    },

    question_status_not_started: { en: "Not started", fr: "Non commencé" },
    question_status_in_progress: { en: "In progress", fr: "En cours" },
    question_status_validated: { en: "Complete", fr: "Validé" },
    question_status_ai_suggestion_success: {
        en: "Generated",
        fr: "Généré",
    },
    question_status_ai_suggestion_failed: {
        en: "Unable to generate",
        fr: "Echec de la génération",
    },
    question_status_answered: {
        en: "Answered",
        fr: "Répondu",
    },
    questionnaire_status_todo: {
        en: "To do",
        fr: "À faire",
    },
    questionnaire_status_in_progress: {
        en: "In progress",
        fr: "En cours",
    },
    questionnaire_status_validated: {
        en: "Validated",
        fr: "Validé",
    },
    instructions_modal_title: {
        en: "Edit your answer with AI",
        fr: "Modifier votre réponse avec l'IA",
    },
    instructions_modal_subtitle: {
        en: "Edit your answer using our AI tools",
        fr: "Modifier votre réponse en utilisant notre outil IA",
    },
    instructions_modal_save: { en: "Save", fr: "Enregistrer" },
    instructions_modal_cancel: { en: "Cancel", fr: "Annuler" },
    instructions_modal_placeholder: {
        en: "Type an instruction...",
        fr: "Entrez une instruction...",
    },
    instructions_ai_actions: {
        en: "AI Actions (Choose a quick one below or write your own)",
        fr: "Actions de l'IA (Choisissez une action rapide ci-dessous ou écrivez la vôtre)",
    },
    instructions_ai_suggestion: {
        en: "AI Suggested Answer",
        fr: "Réponse suggérée par l'IA",
    },

    instructions_modal_new_answer: {
        en: "New answer",
        fr: "Nouvelle réponse",
    },
    instructions_modal_send_suggestion: {
        en: "Edit with AI",
        fr: "Modifier avec l'IA",
    },
    ai_edit_answer_button: {
        en: "Edit with AI",
        fr: "Modifier avec l'IA",
    },
    edit_action_dropdown_trigger: {
        en: "Choose action",
        fr: "Choisir l'action",
    },
    translate_answer_to: {
        en: "Translate the answer to",
        fr: "Traduire la réponse en",
    },
    make_it_more_concise: {
        en: "Make it more concise",
        fr: "Rendre la réponse plus concise",
    },
    make_it_more_detailed: {
        en: "Make it more detailed",
        fr: "Rendre la réponse plus détaillée",
    },
    type_your_own_prompt: {
        en: "Type your own prompt",
        fr: "Entrez votre propre instruction",
    },
    english: {
        en: "English",
        fr: "Anglais",
    },
    french: {
        en: "French",
        fr: "Français",
    },
    german: {
        en: "German",
        fr: "Allemand",
    },
    spanish: {
        en: "Spanish",
        fr: "Espagnol",
    },
    italian: {
        en: "Italian",
        fr: "Italien",
    },
    portuguese: {
        en: "Portuguese",
        fr: "Portugais",
    },
    chinese: {
        en: "Chinese",
        fr: "Chinois",
    },
    japanese: {
        en: "Japanese",
        fr: "Japonais",
    },
    ai_suggestion_pre_filled_prompt_translate_label: {
        en: "Translate Answer",
        fr: "Traduire la réponse",
    },
    ai_suggestion_pre_filled_prompt_concise_label: {
        en: "Make it more concise",
        fr: "Rendre la réponse plus concise",
    },
    ai_suggestion_pre_filled_prompt_detailed_label: {
        en: "Make it more detailed",
        fr: "Rendre la réponse plus détaillée",
    },
    ai_suggestion_pre_filled_prompt_tone_label: {
        en: "Change tone",
        fr: "Changer le ton",
    },
    ai_suggestion_pre_filled_prompt_translate: {
        en: "Translate the answer in",
        fr: "Traduire la réponse en",
    },
    ai_suggestion_pre_filled_prompt_concise: {
        en: "Make the answer more concise",
        fr: "Rendre la réponse plus concise",
    },
    ai_suggestion_pre_filled_prompt_detailed: {
        en: "Make the answer more detailed",
        fr: "Rendre la réponse plus détaillée",
    },
    ai_suggestion_pre_filled_prompt_tone: {
        en: "Change the tone of the answer",
        fr: "Changer le ton de la réponse",
    },
    ai_suggestion_pre_filled_prompt_title: {
        en: "Edit with AI",
        fr: "Modifier avec l'IA",
    },
    language_dropdown_trigger: {
        en: "Choose language",
        fr: "Choisir la langue",
    },
});
export function useQuestionsTabTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);

    return {
        t,
        keys,
    };
}
